import React from "react";
import CapabilityBlock from "../CapabilityBlock/CapabilityBlock";
import FaqBlock from "../FaqBlock/FaqBlock";
import FinalCTABlock from "../FinalCTABlock/FinalCTABlock";
import HeroBlock from "../HeroBlock/HeroBlock";
import HowItWorksBlock from "../HowItWorksBlock/HowItWorksBlock";
import OSAlignmentBlock from "../OSAlignmentBlock/OSAlignmentBlock";
import PricingBlock from "../PricingBlock/PricingBlock";
import RequestWalkthroughForm from "../RequestWalkthroughForm/RequestWalkthroughForm";
import ROIEstimatorBlock from "../ROIEstimatorBlock/ROIEstimatorBlock";
import WhyChooseBlock from "../WhyChooseBlock/WhyChooseBlock";

/**
 * FieldCoach product page — a static, full-bleed marketing surface in the Hub.
 *
 * Each page section is its own `*Block` component owning its copy; this file
 * only composes them in order.
 *
 * Colors come from the shared Tailwind tokens: `primary`/`primary-light` for
 * CertainPath red, `secondary` for navy, plus brand `gold` and `cream`.
 */

const FORM_SECTION_ID = "get-started";

const FieldCoachPage: React.FC = () => (
  <div className="min-h-screen bg-gray-50 dark:bg-slate-950">
    <HeroBlock formSectionId={FORM_SECTION_ID} />

    <OSAlignmentBlock />

    <WhyChooseBlock />

    <ROIEstimatorBlock formSectionId={FORM_SECTION_ID} />

    <CapabilityBlock />

    <HowItWorksBlock />

    <PricingBlock formSectionId={FORM_SECTION_ID} />

    <FaqBlock />

    <RequestWalkthroughForm sectionId={FORM_SECTION_ID} />

    <FinalCTABlock formSectionId={FORM_SECTION_ID} />
  </div>
);

export default FieldCoachPage;
